import { Tabs } from '@creditornot/cb-tabs';
import React, { ReactNode, useState } from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

const Root = styled.div`
  display: flex;
  flex-direction: column;
`;

type Props = {
  performanceContent: ReactNode;
  detailsContent: ReactNode;
};

enum Tab {
  PERFORMANCE = 'performance',
  DETAILS = 'details',
}

export function CampaignTabs({ performanceContent, detailsContent }: Props) {
  const [activeTab, setActiveTab] = useState<Tab>(Tab.PERFORMANCE);
  const { formatMessage } = useIntl();
  return (
    <Root>
      <Tabs<Tab>
        activeTabId={activeTab}
        items={[
          {
            id: Tab.PERFORMANCE,
            label: formatMessage({ id: 'campaigns.analytics-performance-tab' }),
          },
          {
            id: Tab.DETAILS,
            label: formatMessage({ id: 'campaigns.analytics-details-tab-title' }),
          },
        ]}
        onChange={setActiveTab}
      />
      {activeTab === Tab.PERFORMANCE && performanceContent}
      {activeTab === Tab.DETAILS && detailsContent}
    </Root>
  );
}
